import React from 'react';
const ModuleOverview = ({ title, element, attributes }) => {
    return (React.createElement("div", { className: "module-overview" },
        React.createElement("div", { className: "title" }, title),
        React.createElement("ul", null,
            React.createElement("li", { className: "dates", dangerouslySetInnerHTML: { __html: element.dates.formatted } }),
            React.createElement("li", { className: "locations" }, element.location),
            React.createElement("li", { className: "ref" }, element.reference))));
};
export default ModuleOverview;
